<template>
    <section class="sm-b-m">
        <div class="sm-b-s">
            <span class="te-fat-section" :class="[hasSubtitle ? 'sm-b-xs' : '']">{{ section.title | athT }}</span>
            <span v-if="hasSubtitle" class="te-note dashboard-section-subtitle">{{ section.subtitle | athT }}</span>
        </div>
        <comp :is="widgetComponent"
            class="sm-l-s"
            :config="config"
            :dashboardType="dashboardType"
            :dashboard="dashboard"
            :widgetType="widgetType"
            v-bind="section.config"
            @onUpdate="onUpdate" />
    </section>
</template>
<script>
import { isNeString } from '@aretheyhappy/utils';
import DashboardItemConfigMixin from '../mixins/DashboardItemConfigMixin.js';

export default {
    mixins: [DashboardItemConfigMixin],
    props: {
        /**
         * Configuration section definition to render, including its title, optional
         * subtitle, and either a component or a component_key used to resolve the
         * widget that renders this section's settings, along with the config to bind to it.
         */
        section: {type: Object, default: () => ({})},
    },
    methods: {
        onUpdate (key, value) {
            this.sendConfigUpdate(key, value);
        },
    },
    computed: {
        widgetComponent: function () {
            if (this.section.component) return this.section.component;
            if (!isNeString(this.section.component_key)) return false;
            return MeadCommon.DashboardService.getDashboardWidgetComponent(this.section.component_key);
        },
        hasSubtitle: function () {
            return isNeString(this.section.subtitle);
        }
    }
};
</script>
<style lang="scss" scoped>
@use '../../../../../sass/variables' as *;
.dashboard-section-subtitle {
    color: var(--c-txt-light);
}
</style>